import { InMemoryCache } from '@apollo/client/cache/index.js';
import { initApolloClient } from './initApolloClient.js';
import { RemoteApolloClientFactory } from './RemoteApolloClientFactory.js';
/**
 * Initializes an apollo client using the RemoteApolloClientFactory
 * @param initialState - default cache
 * @param headers - next.js server side page context headers
 * @param uri - optional remote uri to use, will fall back to /api/graphql
 */
export function initRemoteApolloClient(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
initialState, headers, uri) {
    return initApolloClient(initialState, new RemoteApolloClientFactory(initialState, headers, uri), {
        cache: new InMemoryCache(),
        headers
    });
}
//# sourceMappingURL=initRemoteApolloClient.js.map